// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UrpP","col":"styles_col__3DZKi","actions":"styles_actions__1Kk-W","conflict":"styles_conflict__11X_6"};